import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import initLocaleConfig from 'config/localeConfig';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { ThemeProvider } from '@mui/material';
import ErrorFallbackView from 'ErrorFallbackView';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import 'config/fontAwesomeIconConfig';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/index.css';
import './assets/css/custom.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-image-crop/dist/ReactCrop.css';
import theme from './theme';

import * as serviceWorker from './serviceWorker';
import App from './App';

// CHARTS DEFAULTS
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// SENTRY CONFIG
////////////////////
const EXCLUDED_EXCEPTION_TYPES = ['ChunkLoadError'];
const EXCLUDED_EXCEPTION_VALUES = [
  'Request failed with status code 401',
  'Request failed with status code 400',
  'Request failed with status code 404',
  'Request failed with status code 403',
  'Network Error',
  'timeout of 20000ms exceeded',
  'Request aborted',
  'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.',
];
const myFallback = <ErrorFallbackView />;
const DIALOG_OPTIONS = { lang: 'pt-br' };

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://a55798cf72fb4d5db7f765d10c4fe91e@o484094.ingest.sentry.io/5563927',
    autoSessionTracking: true,
    environment: process.env.REACT_APP_STAGE ?? 'production',
    beforeSend: (event) => {
      // DROP chunk loading and http errros
      if (event && event.exception && event.exception.values) {
        const firstException = event.exception.values[0];
        if (
          EXCLUDED_EXCEPTION_TYPES.includes(firstException.type) ||
          EXCLUDED_EXCEPTION_VALUES.includes(firstException.value)
        ) {
          return null;
        }
      }
      return event;
    },
  });
}
// SENTRY CONFIG
////////////////////

// locale
initLocaleConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={myFallback} showDialog dialogOptions={DIALOG_OPTIONS}>
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale="pt-br"
      localeText={{ datePickerToolbarTitle: 'Data', cancelButtonLabel: 'Cancelar' }}
    >
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </LocalizationProvider>
  </Sentry.ErrorBoundary>,
);

serviceWorker.unregister();
